/* Config */
export const SIDEBAR_TOGGLE = '__sidebarToggle'
export const SET_SIDEBAR = '__setSidebar'
export const SET_REQUEST_IN_PROGRESS = '__setRequestInProgress'
export const INCREASE_AXIOS_REQUEST = '__increaseAxiosRequest'
export const DECREASE_AXIOS_REQUEST = '__decreaseAxiosRequest'
export const SET_UI_PREFERENCES = '__setUiPreferences'

export default {
  SIDEBAR_TOGGLE,
  SET_SIDEBAR,
  SET_REQUEST_IN_PROGRESS,
  INCREASE_AXIOS_REQUEST,
  DECREASE_AXIOS_REQUEST,
  SET_UI_PREFERENCES
}
